export const musicData = [
    {
    id: 0,
    title: "Hulog",
    artist: "KAIA",
    releaseDate: "2026",
    image: "%PUBLIC_URL%/assets/img/music-hulog.png",
    audio: "%PUBLIC_URL%/assets/audio/music-hulog.mp3",
    lyrics: `[Verse 1: Sophia]
Lagi, ba't ba palagi walang masabi?
Pero mata'y nagtitinginan
Nag-iindakan, 'di mapigilan
Ba't ko ba tatanggihan?

[Pre-Chorus: Angela]
Kasi hindi ka maalis sa isip lumalabis
Kailan ko ba 'to haharapin?

[Chorus: Charlotte]
Hindi ka mawala, natutulala
Hindi maipaliwanag ang nadarama
Hindi maisantabi, 'di maitatanggi
Nahuhulog na rin 'ata, hulog na rin 'ata sa 'yo, ooh-woah

[Verse 2: Angela]
Hanap, lagi kong hanap
Higpit ng yakap, pero 'di mahingi
'Pag ikaw ay, ikaw ay kaharap
'Di makausap, pa'no uusad?

[Pre-Chorus: Alexa]
Gabi-gabing panaginip, ikaw lang ang nasa tabi
Nawawala buong mundo, buong puso nasa iyo
Paano ba susulong pa? Pag-ibig na 'di magbunga
'Di malabas ang salita


[Chorus: Charice]
Hindi ka mawala, natutulala
Hindi maipaliwanag ang nadarama
Hindi maisantabi, 'di maitatanggi
Nahuhulog na rin 'ata, hulog na rin 'ata sa 'yo

[Post-Chorus: Charice]
Ooh-oh (Oh), oh-oh (Oh)
Hulog na rin 'ata, hulog na rin 'ata sa 'yo
Ooh-oh (Oh), oh-oh (Oh)
Hulog na rin 'ata, nahuhulog na rin ata sa'yo

[Bridge: Alexa]
'Di mawari gagawin ko
Nahuhulog na buong mundo
Nahuhulog na rin ako sa 'yo
Sa 'yo, sa 'yo

[Chorus: Sophia]
Hindi ka mawala, natutulala
Hindi maipaliwanag ang nadarama
Hindi maisantabi, 'di maitatanggi
Nahuhulog na rin 'ata, hulog na rin 'ata sa 'yo

[Post-Chorus: Sophia]
Ooh-oh (Oh), oh-oh (Oh)
Hulog na rin 'ata, hulog na rin 'ata sa 'yo
Ooh-oh (Oh), oh-oh (Oh)
Hulog na rin 'ata, nahuhulog na rin ata sa 'yo`
  },
    {
    id: 1,
    title: "Tara Sayaw",
    artist: "KAIA",
    releaseDate: "2025",
    image: "%PUBLIC_URL%/assets/img/music-tara-sayaw.png",
    audio: "%PUBLIC_URL%/assets/audio/music-tarasayaw.mp3",
    lyrics: `Dati ay tahimik
Sunod sunod lang sa agos
Mayro'ng bago sa aking sarili
I'm not scared
Kayang-kayang bumangon
Now I know, I'm growing wings
Taking flight, 'di mapakali
Feel that beat
Come on touch the sky
Feeling so alive
Tara na't sayaw!
Hataw na! Galaw!
Feel the rhythm
And the music of life
Tara na't sayaw!
Hataw na! Galaw!
Feel the rhythm
And the music of life
Come on! Let's sing it out
Sumayaw (sumayaw)
Hataw na! Galaw! (gumalaw)
Tara na't sayaw! (sumayaw)
Tara na't sayaw!
Say hello to the timeless and new
Gonna teach you a thing or two
Aking tinig, tono't sayaw
Buong puso, sisigaw
Now I know I'm growing wings
Taking flight, 'di mapakali
Feel that beat
Come on touch the sky
Feeling so alive
Tara na't sayaw!
Hataw na! Galaw!
Feel the rhythm
And the music of life
Tara na't sayaw!
Hataw na! Galaw!
Feel the rhythm
And the music of life
Come on! Let's sing it out
Sumayaw (sumayaw)
Hataw na! Galaw! (gumalaw)
Tara na't sayaw! (sumayaw)
Tara na't sayaw! (sumayaw)
Tara na't sayaw!
Hataw na! Galaw!
Feel the rhythm
And the music of life
Tara na't sayaw!
Hataw na! Galaw!
Feel the rhythm
And the music of life
Come on! Let's sing it out
Sumayaw (sumayaw)
Hataw na! Galaw! (gumagalaw)
Tara na't sayaw! (sumasayaw)
Tara na't sayaw! (sumasayaw)`
  },
  {
    id: 2,
    title: "Walkie Talkie",
    artist: "KAIA",
    releaseDate: "2025",
    image: "%PUBLIC_URL%/assets/img/music-walkietalkie.png",
    audio: "%PUBLIC_URL%/assets/audio/music-walkietalkie.mp3",
    lyrics: `Hm, hm Hello? I have been thinking a lot about you lately And I was wondering if you were as well? Do you copy over?

♬ ♬ ♬

Don't know if I should, I'd stop if I could Don't know how I live anymore without thinking 'bout you, boy, yeah

Now, just look at the time, 11:59 If you got a minute, I'm about to give you all the signs
Should we just talk all night? You know that it's alright Why don't you make your move just vibe with me?
Don't keep me waiting I know I'm there, I'm always in your mind
Oh, baby, now I'm gonna break it to you, oh You got me feeling for you, boy

Come now, get on my frequency Tune in so we can walkie-talkie
Do you hear me over? Baby, come here closer I just wanna hear you better
D-O Y-O-U copy? Check that walkie-talkie, baby
D-O Y-O-U copy? Check that walkie-talkie, baby

♬ ♬ ♬

Can't figure out what to do, what's in the manual? Don't know how to function, is this the button?
Or something for me to click with you? Yeah, reply without delay
'Lam mo naman, I like your name on my notification every day Not a clue, I can't decode it, dama kong ikaw ay lumalapit
Ano bang mga 'di sinasabi? Iniisip palagi-lagi You won't stop, sweet like a soda pop, yeah
I know you're not like any other

Don't keep waiting I know I'm there, I'm always in your mind
Oh, baby, now I'm gonna break it to you, oh You got me feeling for you, boy, yeah
Got me feeling for you Feeling for you

Come now, get on my frequency Tune in so we can walkie-talkie
Do you hear me over? Baby, come here closer I just wanna hear you better
Tell me now, so we can see Tune up, come on, let's walkie-talkie
My heart's getting closer, baby, come on over I wanna be with you forever

D-O Y-O-U copy? Check that walkie-talkie, baby
D-O Y-O-U copy?Check that, check that Check that, check that`
  },
  {
    id: 3,
    title: "Tanga",
    artist: "KAIA",
    releaseDate: "2025",
    image: "%PUBLIC_URL%/assets/img/music-tanga.png",
    audio: "%PUBLIC_URL%/assets/audio/music-tanga.mp3",
    lyrics: `...

Matagal ko nang napapansin, minsan ay nagpipigil
Kasi nga ayokong na masasaktan kita
Maraming nagsasabi na isa kang malaking problema
Pero 'di naman ako naalis kahit na

Sabi nga ni mama, Wag kang magtitiwala
Sa mga lalaking gaya mong masyadong magaling sa drama
Lupit sa pabango, tunay na baho mo
Sa loob 'di mo matago, alam kong 'di makuntento

Huwag kang magagalit, kung ayoko nang kumapit
Sinusubukan ko lahat ng makakaya ko
Huwag sanang magalit kung nalulungkot palagi
Ayaw ka ng lahat pero andito pa rin ako

Na-na-na-na-na-na, na-na-na-na-na
Na-na-na-na-na-na, na-na-na-na-na

Di naman ako nagtitiwala na (Nagtitiwala na)
Kasi nga laro mo'y kabisado na (Kabisado na)
Sino bang niloko ko, alam kong hindi 'to totoo
Ngayon lang galit-galitan 'to, pero inlove pa rin naman sa'yo

Sabi nga ni mama, Wag kang tanga-tanga (Tanga)
Huwag magpapaloko sa gaya mong magaling sa salita (Magaling sa salita)
Pero nakuha mo, marupok na puso ko
Di makapaniwala, nahulog sa isang tulad mo

Huwag kang magagalit, kung ayoko nang kumapit
Sinusubukan ko lahat ng makakaya ko (Okay)
Huwag sanang magalit kung nalulungkot palagi
Ayaw ka ng lahat pero andito pa rin ako

Na-na-na-na-na-na, na-na-na-na-na
Na-na-na-na-na-na, na-na-na-na-na
Na-na-na-na-na-na, na-na-na-na-na
Na-na-na-na-na-na, na-na-na-na-na

Nandito pa rin ako
Nandito pa rin ako`
  },
  {
    id: 4,
    title: "Walang Biruan Christmas Edition",
    artist: "KAIA",
    releaseDate: "2024",
    image: "%PUBLIC_URL%/assets/img/music-walangbiruan-christmasedition.png",
    audio: "%PUBLIC_URL%/assets/audio/music-walangbiruanchristmasrush.mp3",
    lyrics: `[Intro: Charice, Angela]
Walang biro, walang biruan
Walang biro, walang biruan

[Verse 1: Charlotte, Sophia]
Paminsan, mahirap tumindig nang mag-isa
Nakakapagod, nakakalula, you're on my mind
Gusto kitang yakapin at mapasa'kin kailanman
Sabihin mo lahat ng mga pangarap mo
Tulungan natin isa't isa makamit ito
O kahit ma'y libot-libot basta't tayong dalawa

[Refrain: Angela]
Alam mo ba na ikaw lang ang hinahanap ko
Saan man magpunta, tangi, sa'yo lang patungo
I don't know, pwede ba? I won't know, kailan pa?
Na tayo lamang, ni walang kasama

[Chorus: Charice]
Kasi ikaw, ikaw, ikaw, ikaw, ikaw laman ng puso't isip ko
Sa'yong-sa'yo, sa'yo, sa'yo ako pinagtagpo
Sa'yong-sa'yo, sa'yong-sa'yo walang biro
Walang biro, walang biruan

[Verse 2: Alexa, Sophia]
Mga alaala kumikinang 'pag ika'y kasama
'Di na nga mapakali, hinahanap 'pag wala ka
Ginayuma ba ako? Ako'y naninibago
Hindi ko maintindihan kung bakit ganito
Mundo ko'y paikot-ikot, ako ay nahihilo
Nakatitig sa ngiti mo, 'di mabaon sa limot

[Chorus: Charice]
Kasi ikaw, ikaw, ikaw, ikaw, ikaw laman ng puso't isip ko
Sa'yong-sa'yo, sa'yo, sa'yo ako pinagtagpo
Sa'yong-sa'yo, sa'yong-sa'yo walang biro
Walang biro, walang biruan

[Refrain: Angela, Charice]
Alam mo ba na ikaw lang ang hinahanap ko
Saan man magpunta, tangi, sa'yo lang patungo
I don't know, pwede ba? I won't know, kailan pa?
Na tayo lamang, ni walang kasama
Kasi ikaw`
  },
  {
    id: 5,
    title: "Walang Biruan",
    artist: "KAIA",
    releaseDate: "2024",
    image: "%PUBLIC_URL%/assets/img/music-walangbiruan.png",
    audio: "%PUBLIC_URL%/assets/audio/music-walangbiruan.mp3",
    lyrics: `[Intro: Charice, Angela]
Walang biro, walang biruan
Walang biro, walang biruan

[Verse 1: Charlotte, Sophia]
Paminsan, mahirap tumindig nang mag-isa
Nakakapagod, nakakalula, you're on my mind
Gusto kitang yakapin at mapasa'kin kailanman
Sabihin mo lahat ng mga pangarap mo
Tulungan natin isa't isa makamit ito
O kahit ma'y libot-libot basta't tayong dalawa

[Refrain: Angela]
Alam mo ba na ikaw lang ang hinahanap ko
Saan man magpunta, tangi, sa'yo lang patungo
I don't know, pwede ba? I won't know, kailan pa?
Na tayo lamang, ni walang kasama

[Chorus: Charice]
Kasi ikaw, ikaw, ikaw, ikaw, ikaw laman ng puso't isip ko
Sa'yong-sa'yo, sa'yo, sa'yo ako pinagtagpo
Sa'yong-sa'yo, sa'yong-sa'yo walang biro
Walang biro, walang biruan

[Verse 2: Alexa, Sophia]
Mga alaala kumikinang 'pag ika'y kasama
'Di na nga mapakali, hinahanap 'pag wala ka
Ginayuma ba ako? Ako'y naninibago
Hindi ko maintindihan kung bakit ganito
Mundo ko'y paikot-ikot, ako ay nahihilo
Nakatitig sa ngiti mo, 'di mabaon sa limot

[Chorus: Charice]
Kasi ikaw, ikaw, ikaw, ikaw, ikaw laman ng puso't isip ko
Sa'yong-sa'yo, sa'yo, sa'yo ako pinagtagpo
Sa'yong-sa'yo, sa'yong-sa'yo walang biro
Walang biro, walang biruan

[Refrain: Angela, Charice]
Alam mo ba na ikaw lang ang hinahanap ko
Saan man magpunta, tangi, sa'yo lang patungo
I don't know, pwede ba? I won't know, kailan pa?
Na tayo lamang, ni walang kasama
Kasi ikaw`
  },
  {
    id: 6,
    title: "You Did It",
    artist: "KAIA",
    releaseDate: "2024",
    image: "%PUBLIC_URL%/assets/img/music-youdidit.png",
    audio: "%PUBLIC_URL%/assets/audio/music-youdidit.mp3",
    lyrics: `[Intro]
R-r-real recognize real

[Verse 1: Charice, Alexa, Sophia, Charlotte]
Kita sa mata, baliktad sila 'pag nanalamin
Mga namuna na nag-aabang na pabagsakin
Paniniwala akala nila kayang burahin
Sa'kin humarap kang nagpapanggap, diretsong tingin
'Cause it's a lie
Mahigpit ang kapit, nagtanim ng galit
It's a lie
Aking aanihin 'tong 'di matahimik (Woah-oh)

[Pre-Chorus: Angela]
Nagbubulag-bulagan kahit kitang-kita ko, oh-o`
  }
];